import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MatTimeService {
  public formatNumber(value: number, minimumIntegerDigits = 2): string {
    return Math.floor(value).toLocaleString('en-US', { minimumIntegerDigits, useGrouping: false });
  }
}
